import { render, staticRenderFns } from "./userCalling.vue?vue&type=template&id=3cffa181&scoped=true"
import script from "./userCalling.vue?vue&type=script&lang=js"
export * from "./userCalling.vue?vue&type=script&lang=js"
import style0 from "./userCalling.vue?vue&type=style&index=0&id=3cffa181&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cffa181",
  null
  
)

export default component.exports